//const baseUrl = "https://4i2f5way3slxupj3rkqood3wje0txtca.lambda-url.us-east-1.on.aws/api/"
// const baseUrl = "https://lifepadi-v2-225229879541.us-east1.run.app/api/" GCP-2
const baseUrl = "https://api.lifepadi.com/api/";
//"https://lifepadi-948405839190.us-east1.run.app/api/"; GCP-1
//const baseUrl ='https://localhost:7216/api/'
//'http://localhost:3500/'
export default baseUrl
